import { genStyleHook } from './../__builtins__';
export default genStyleHook('preview-text', function (token) {
    var _a, _b;
    var componentCls = token.componentCls, antCls = token.antCls, fontSize = token.fontSize, fontWeightStrong = token.fontWeightStrong;
    return [
        (_a = {},
            _a[componentCls] = (_b = {
                    fontSize: fontSize,
                    fontWeight: fontWeightStrong
                },
                _b["".concat(antCls, "-tag:last-child")] = {
                    marginInlineEnd: 0,
                },
                _b),
            _a),
    ];
});
//# sourceMappingURL=style.js.map